"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MqttTopic = void 0;
var MqttTopic;
(function (MqttTopic) {
    MqttTopic["Alarm"] = "alarm";
    MqttTopic["Heartbeat"] = "heartbeat";
    MqttTopic["Intended"] = "intended";
    MqttTopic["Notification"] = "notification";
    MqttTopic["Percent"] = "percent";
    MqttTopic["Pressure"] = "pressure";
    MqttTopic["Reported"] = "reported";
    MqttTopic["Schedules"] = "schedules";
    MqttTopic["Status"] = "status";
    MqttTopic["Temperature"] = "temp";
    MqttTopic["Trigger"] = "trigger";
    MqttTopic["Voltage"] = "voltage";
})(MqttTopic = exports.MqttTopic || (exports.MqttTopic = {}));
//# sourceMappingURL=MqttTopic.js.map